import type { Severity } from '@prerender/diagnostics-api';

import { domainStateLabel } from './domainStateLabels';
import SeverityTag from './SeverityTag';

type CrawlerStandingCellProps = {
  severity: Severity;
  noLongerAffected: boolean;
};

function CrawlerStandingCell({ severity, noLongerAffected }: CrawlerStandingCellProps) {
  if (!noLongerAffected) {
    return (
      <td>
        <SeverityTag severity={severity} />
      </td>
    );
  }
  return (
    <td>
      <span className="visually-hidden">{`${domainStateLabel('no_longer_affected')}, was `}</span>
      <SeverityTag severity={severity} muted />
    </td>
  );
}

export default CrawlerStandingCell;
